module.exports = __webpack_public_path__ + "img/icon-type-1.91a744cd.png";